import React from 'react';

import FindFilters from './filters/FindFilters';
import ContentList from './content-list/ContentList';

import scss from './Find.module.scss';

function Find() {
  return (
    <div className={scss.wrapper}>
      <FindFilters />

      <ContentList />
    </div>
  );
}

export default Find;
